<template>
  <div class="code-input">
    <input
      v-for="(item, index) in inputs"
      :key="index"
      type="text"
      maxlength="1"
      inputmode="numeric"
      v-model="inputs[index]"
      ref="inputs"
      @input="onInput(index)"
      @keydown.backspace="onBackspace(index)"
      class="code-box"
    />
  </div>
</template>

<script>
export default {
  name: 'VerificationCodeInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    length: {
      type: Number,
      default: 6
    }
  },
  data() {
    return {
      inputs: Array(this.length).fill('')
    };
  },
  watch: {
    inputs: {
      deep: true,
      handler() {
        const code = this.inputs.join('');
        this.$emit('input', code);
      }
    }
  },
  mounted() {
    this.$refs.inputs[0].addEventListener('paste', this.handlePaste);
  },
  destroyed() {
    this.$refs.inputs[0].removeEventListener('paste', this.handlePaste);
  },
  methods: {
    onInput(index) {
      const val = this.inputs[index];
      if (val && val.length === 1 && index < this.length - 1) {
        this.$refs.inputs[index + 1].focus();
      }
    },
    onBackspace(index) {
      if (!this.inputs[index] && index > 0) {
        this.$refs.inputs[index - 1].focus();
      }
    },
    handlePaste(e) {
      const paste = e.clipboardData.getData('text').slice(0, this.length);
      for (let i = 0; i < paste.length; i++) {
        this.inputs[i] = paste[i];
      }
      this.$nextTick(() => {
        this.$refs.inputs[Math.min(paste.length, this.length - 1)].focus();
      });
      e.preventDefault();
    }
  }
};
</script>

<style scoped>
.code-input {
  display: flex;
  gap: 10px;
}
.code-box {
  width: 28px;
  height: 28px;
  text-align: center;
  font-size: 20px;
  /*border: 1px solid #ccc;*/
  border: 1px solid #D51315;
  border-radius: 6px;
}
.code-box:focus {
  outline: 2px solid #DE2726;
  border: 1px solid #fff;
}
</style>
